import { formatNumber } from '../lib/format';
import type { TopBottomResponse, TopBottomRow } from '../types';

type Props = {
  data: TopBottomResponse;
  onDrillIn: (afNumber: string) => void;
};

export default function TopBottomTables({ data, onDrillIn }: Props) {
  if (!data || (!data.top?.length && !data.bottom?.length)) return null;
  return (
    <div className="ds-split">
      <Panel title="Top Performers" meta="Click to drill in" rows={data.top} markerClass="green" answerColor="#16a34a" onDrillIn={onDrillIn} />
      <Panel title="Needs Attention" meta="Below target" rows={data.bottom} markerClass="red" answerColor="#dc2626" showIssue onDrillIn={onDrillIn} />
    </div>
  );
}

function Panel({
  title,
  meta,
  rows,
  markerClass,
  answerColor,
  showIssue = false,
  onDrillIn,
}: {
  title: string;
  meta: string;
  rows: TopBottomRow[];
  markerClass: 'green' | 'red';
  answerColor: string;
  showIssue?: boolean;
  onDrillIn: (afNumber: string) => void;
}) {
  return (
    <div className="ds-panel">
      <div className="ds-panel-header">
        <h3>{title}</h3>
        <span className="meta">{meta}</span>
      </div>
      <table className="ds-table">
        <thead>
          <tr>
            <th style={{ width: 28 }}></th>
            <th>Franchisee</th>
            <th className="num">Calls</th>
            <th className="num">Answer</th>
            {showIssue ? <th>Issue</th> : <th className="num">Booking</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.afNumber} onClick={() => onDrillIn(r.afNumber)}>
              <td>
                <span className={`ds-marker ${markerClass}`} />
              </td>
              <td>
                <div className="ds-name">{r.name || r.afNumber}</div>
                {r.location && <div className="ds-sub">{r.location}</div>}
              </td>
              <td className="num">
                <span className="num-val">{formatNumber(r.totalCalls)}</span>
              </td>
              <td className="num">
                <span className="num-pct" style={{ color: answerColor }}>
                  {r.answerRate}%
                </span>
              </td>
              {showIssue ? (
                <td style={{ fontSize: 11, color: '#dc2626', fontWeight: 600 }}>{r.issue ?? ''}</td>
              ) : (
                <td className="num">
                  <span className="num-pct">{r.bookingRate}%</span>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
